export default __webpack_public_path__ + "BenjaminDenoyer.5e1ada3.jpg";